// Generated by CoffeeScript 1.12.6
(function() {
  module.exports = {
    toaster: {},
    toast: {
      data: function() {
        return {
          enter: {
            style: {
              opacity: [0, 1],
              top: [35, 0, "px"]
            },
            duration: 300
          },
          leave: {
            style: {
              opacity: [1, 0]
            },
            duration: 200
          }
        };
      },
      methods: {
        move: function(o) {
          var move;
          move = o.move;
          this.style.transform = "translateX(" + move + "px)";
          return this.style.opacity = o.opacity = 1 - Math.abs(move / this.offsetWidth);
        },
        unMove: function(o) {
          return {
            style: {
              translateX: [o.move, 0, "px"],
              opacity: [o.opacity, 1]
            }
          };
        },
        endMove: function(o) {
          return this.style.transform = "";
        }
      },
      computedClass: {
        "this": function() {
          return this.toast["class"] || {};
        }
      }
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-toaster/materialize.js
// module id = 71
// module chunks = 1